import { useState } from "react";

import { putData } from "../../Services/apiService";
import { useAlert } from "../../Provider/Alert/AlertContext";
import { useTranslation } from "react-i18next";

// Hook para o formulário de senha do usuário
export function usePasswordForm({ user, onClose }) {
    const { t } = useTranslation(); // Hook para tradução
    const { addAlert } = useAlert(); // Hook para os alertas

    // Hook para os dados do formulário
    const [passwordForm, setPasswordForm] = useState({
        password: "",
        confirm_password: "",
    });

    // Enviar dados do formulário
    const handleFormSubmit = () => {

        console.log("passwordForm", passwordForm);
        
        // Envia os dados do formulário
        const changePassword = putData(
            `/user/${user.id}/password`,
            null,
            passwordForm
        );
        changePassword.then((response) => {
            console.log(response);
            if (response.status === 200) {
                addAlert(
                    "success",
                    t("users.form.password-change.success.title"),
                    t("users.form.password-change.success.message")
                );
                onClose();
                setPasswordForm({ password: "", confirm_password: "" });
            } else {
                addAlert(
                    "danger",
                    t("users.form.password-change.error.title") +
                        " " +
                        response.status,
                    response.body
                );
            }
        });
    };

    const handleCancel = () => {
        setPasswordForm({
            password: "",
            confirm_password: "",
        });
        onClose();
    };

    return {
        passwordForm,
        setPasswordForm,
        handleFormSubmit,
        handleCancel,
    };
}
